<script>
import * as m from '@app/paraglide/messages.js';
import {authState} from '@app/store/authStore.svelte.js';
import {
    explorerState
} from '@app/store/explorerStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import {
    environment
} from '@app/store/envStore.svelte.js';
import {
    eventGroupState, isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import { isNonTranscribableSource } from '@app/lib/player/mediaSources.js';
import {
    secondaryToolbarState,
    getSlotItemsWithSeparators
} from '@app/lib/toolbar/secondaryToolbarConfig.svelte.js';
/* Components */
import OfflineSaveIcon from "./menus/items/OfflineSaveIcon.svelte";
import OnlineSaveIcon from "./menus/items/OnlineSaveIcon.svelte";
import ExportFile from './controls/ExportFile.svelte';
import ImportFile from './controls/ImportFile.svelte';
import Undo from './controls/Undo.svelte';
import Redo from './controls/Redo.svelte';
import Shortcuts from './controls/Shortcuts.svelte';
import AddEvent from './controls/AddEvent.svelte';
import RemoveEvent from './controls/RemoveEvent.svelte';
import AlignLeft from './controls/AlignLeft.svelte';
import AlignCenter from './controls/AlignCenter.svelte';
import AlignRight from './controls/AlignRight.svelte';
import Copy from './controls/Copy.svelte';
import Cut from './controls/Cut.svelte';
import Paste from './controls/Paste.svelte';
import Split from './controls/Split.svelte';
import Merge from './controls/Merge.svelte';
import Expand from './controls/Expand.svelte';
import Compress from './controls/Compress.svelte';
import AutoFormatButton from './controls/AutoFormatButton.svelte';
import Position from './controls/Position.svelte';
import WritingMode from './controls/WritingMode.svelte';
import PositionLineUp from './controls/PositionLineUp.svelte';
import PositionLineDown from './controls/PositionLineDown.svelte';
import ShiftWordBack from './controls/ShiftWordBack.svelte';
import ShiftWordForward from './controls/ShiftWordForward.svelte';
import ShiftLineBack from './controls/ShiftLineBack.svelte';
import ShiftLineForward from './controls/ShiftLineForward.svelte';
import SnapToStart from './controls/SnapToStart.svelte';
import SnapToEnd from './controls/SnapToEnd.svelte';
import SecondaryToolbarSlot from './SecondaryToolbarSlot.svelte';

let isLocked = $derived(isSelectedEventGroupLocked());

let leftItems = $derived(getSlotItemsWithSeparators(secondaryToolbarState.layout.left));
let centerItems = $derived(getSlotItemsWithSeparators(secondaryToolbarState.layout.center));
let rightItems = $derived(getSlotItemsWithSeparators(secondaryToolbarState.layout.right));

function openProject(){
    explorerState.context = "load";
    showModal("storageExplorer");
}

function guardedShowModal(modalName){
    if (isSelectedEventGroupLocked()){
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }
    showModal(modalName);
}

</script>

<nav class="navbar navbar-expand bg-light bg-opacity-50 shadow cc-toolbar-secondary" aria-label={m.toolbar_secondary_aria_label()} style="height: 3vh;">
    <div class="container-fluid">
        <div class="collapse navbar-collapse" id="secondary-toolbar">
            {#if !environment.iframe}
            <ul class="nav navbar-nav" aria-label={m.toolbar_secondary_file_operations_aria_label()}>
                    {#if !environment.online || projectState.useLocalStorage}
                        <li class="nav-item">
                            <a class="nav-link" href="#!/" id="open-project-btn" aria-label={m.toolbar_secondary_open_project_aria_label()} onclick={() => showModal("projectImport")}><i class="bi bi-folder" aria-hidden="true"></i></a>
                        </li>
                    {:else}
                        <li class="nav-item">
                            <a class="nav-link" href="#!/" id="open-project-btn" aria-label={m.toolbar_secondary_open_project_aria_label()} onclick={() => openProject()}><i class="bi bi-folder" aria-hidden="true"></i></a>
                        </li>
                    {/if}
                    {#if !environment.online || projectState.useLocalStorage}
                        <OfflineSaveIcon></OfflineSaveIcon>
                    {:else}
                        <OnlineSaveIcon></OnlineSaveIcon>
                    {/if}                
                    <div class="vr align-self-center" role="separator"></div>
                    <ExportFile></ExportFile>
                    <ImportFile></ImportFile>
                    <div class="vr align-self-center" role="separator"></div>      
                    <li class="nav-item" title={m.toolbar_secondary_import_media_title()}>
                        <a aria-label={m.toolbar_secondary_import_media_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('mediaImport')}><i class="bi bi-collection-play"></i></a>
                    </li>     
                    <div class="vr align-self-center" role="separator"></div>     
                    <Undo></Undo>
                    <Redo></Redo>
                    {#if environment.online}
                        <div class="vr align-self-center" role="separator"></div>
                        <li class="nav-item" title={m.toolbar_secondary_automatic_transcription_title()}>
                            <a aria-label={m.toolbar_secondary_automatic_transcription_aria_label()} class="nav-link {!projectState.media.path || isNonTranscribableSource(projectState.media.storage) ? 'disabled' : ''}" href="#!/" onclick={() => showModal('automaticTranscription')}><i class="bi bi-mic"></i><sub><i class="bi bi-blockquote-left"></i></sub></a>
                        </li>  
                        {#if authState.plan === 'pro' || authState.plan === 'enterprise'}
                        <li class="nav-item" title={m.toolbar_secondary_automatic_translation_title()}>
                            <a aria-label={m.toolbar_secondary_automatic_translation_aria_label()} class="nav-link {!eventGroupState[projectState.selected] || isLocked ? 'disabled' : ''}" href="#!/" onclick={() => guardedShowModal('automaticTranslation')}><i class="bi bi-translate"></i></a>
                        </li>  
                        {/if}
                    {/if}
                    <div class="vr align-self-center" role="separator"></div>
                    <li class="nav-item" title={m.toolbar_secondary_settings_title()}>
                        <a aria-label={m.toolbar_secondary_options_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('options')}><i class="bi bi-gear"></i></a>
                    </li> 
                    <Shortcuts></Shortcuts>
            </ul>
            <ul class="nav navbar-nav ms-auto" aria-label={m.toolbar_secondary_caption_editing_aria_label()}>
                <AddEvent></AddEvent>
                <RemoveEvent></RemoveEvent>
                <div class="vr align-self-center" role="separator"></div>
                <AlignLeft></AlignLeft>
                <AlignCenter></AlignCenter>
                <AlignRight></AlignRight>
                <WritingMode></WritingMode>
                <div class="vr align-self-center" role="separator"></div>
                <Position></Position>                
                <PositionLineUp></PositionLineUp>
                <PositionLineDown></PositionLineDown>
                <div class="vr align-self-center" role="separator"></div>
                <Copy></Copy>
                <Cut></Cut>
                <Paste></Paste>
                <div class="vr align-self-center" role="separator"></div>
                <ShiftWordBack></ShiftWordBack>
                <ShiftWordForward></ShiftWordForward>
                <ShiftLineBack></ShiftLineBack>
                <ShiftLineForward></ShiftLineForward>
                <div class="vr align-self-center" role="separator"></div>
                <Split></Split>
                <Merge></Merge>
                <div class="vr align-self-center" role="separator"></div>
                <Expand></Expand>
                <Compress></Compress>
                <AutoFormatButton></AutoFormatButton>
                <div class="vr align-self-center" role="separator"></div>
                <SnapToStart></SnapToStart>
                <SnapToEnd></SnapToEnd>                                
            </ul>
            {:else}
            <SecondaryToolbarSlot
                items={leftItems}
                ariaLabel={m.toolbar_secondary_file_operations_aria_label()}
                slotClass="cc-toolbar-slot-left"
            />
            {#if centerItems.length > 0}
                <SecondaryToolbarSlot
                    items={centerItems}
                    ariaLabel={m.toolbar_secondary_aria_label()}
                    slotClass="cc-toolbar-slot-center"
                />
            {/if}
            <SecondaryToolbarSlot
                items={rightItems}
                ariaLabel={m.toolbar_secondary_caption_editing_aria_label()}
                slotClass="cc-toolbar-slot-right"
            />
            {/if}
        </div>
    </div>
</nav>

<style lang="css">
.cc-toolbar-secondary {
    padding-block: 0;
}

.cc-toolbar-secondary :global(.container-fluid),
.cc-toolbar-secondary :global(.navbar-collapse),
.cc-toolbar-secondary :global(.navbar-nav),
.cc-toolbar-secondary :global(.nav-item) {
    height: 100%;
}

.cc-toolbar-secondary :global(.navbar-collapse) {
    display: flex;
    width: 100%;
}

.cc-toolbar-secondary :global(.cc-toolbar-slot) {
    flex: 1;
    min-width: 0;
}

.cc-toolbar-secondary :global(.cc-toolbar-slot-left) {
    justify-content: flex-start;
}

.cc-toolbar-secondary :global(.cc-toolbar-slot-center) {
    justify-content: center;
}

.cc-toolbar-secondary :global(.cc-toolbar-slot-right) {
    justify-content: flex-end;
}

ul {
    align-items: center;
}

.cc-toolbar-secondary :global(.nav-link) {
    display: flex;
    align-items: center;
    height: 100%;
    padding-block: 0;
    font-size: 0.75vw;
}

.cc-toolbar-secondary :global(.btn-group) {
    height: 100%;
    align-items: stretch;
}

.cc-toolbar-secondary :global(.dropdown-toggle-split) {
    height: unset;
    align-self: stretch;
    justify-content: center;
    min-width: 1.15rem;
    padding-inline: 0.3rem;
    font-size: 0.7rem;
}

.cc-toolbar-secondary :global(.dropdown-toggle-split::after) {
    margin: 0;
    vertical-align: 0;
    border-top-width: 0.4em;
    border-right-width: 0.35em;
    border-left-width: 0.35em;
}
</style>
